import { render, staticRenderFns } from "./employeeSettings.vue?vue&type=template&id=64a1f40f&scoped=true"
import script from "./employeeSettings.vue?vue&type=script&lang=js"
export * from "./employeeSettings.vue?vue&type=script&lang=js"
import style0 from "./employeeSettings.vue?vue&type=style&index=0&id=64a1f40f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a1f40f",
  null
  
)

export default component.exports